import { useSelector } from 'react-redux';
import { RootState } from 'reducers/store';

export const useNewUser = () => {
  const user = useSelector((state: RootState) => state.user);
  if (!user) return true;

  const firstLoginDate = new Date(user.firstLogin);
  const limitDate = new Date('2025-09-01T00:00:00Z');
  return firstLoginDate > limitDate;
};
